export default {
    'kucoin': {
        param: 'password',
        label: 'Password',
        type: 'extra'
    },
    'stex': {
        param: 'token',
        label: 'Token',
        type: 'only'
    },
    'uniswap': {
        param: 'password',
        label: "Private key of your wallet",
        type: 'only',
    }
}